export class BaseValue {
    constructor(d = { values: [] }) {
        this.values = Object.freeze([...d.values]);
    }
    get() {
        return [...this.values];
    }
}
